import { Box } from "@mui/material";
import HiddenInput from "atoms/HiddenInput";
import { manageEmailingSenders } from "misc/permissionHelpers";
import { ExternalEmailTemplateRecordType } from "pages/ExternalEmailTemplate/ExternalEmailTemplate.types";
import { useEffect } from "react";
import { Fragment } from "react/jsx-runtime";
import {
  AutocompleteInput,
  AutocompleteInputProps,
  ReferenceInput,
  required,
  TextInput,
  useChoicesContext,
} from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";

import { EmailSenderRecordType } from "../../pages/SharedRecords.types";
import { EmailTemplateAndSubjectInputPropsType } from "./SendEmailDialog.types";

function HideableAutocompleteInput(
  props: { defaultTemplate: ExternalEmailTemplateRecordType } & AutocompleteInputProps,
) {
  const { defaultTemplate, ...rest } = props;
  const { allChoices } = useChoicesContext();
  const { setValue } = useFormContext();
  const sender = useWatch<{ sender: number }>({ name: "sender" });

  useEffect(() => {
    if (allChoices?.length === 1) {
      setValue("sender", allChoices[0].id, { shouldDirty: true });
    }
  }, [allChoices]);

  return (
    <Box sx={{ display: defaultTemplate.sender && sender && allChoices && allChoices.length === 1 ? "none" : "block" }}>
      <AutocompleteInput {...rest} />
    </Box>
  );
}

export default function EmailTemplateAndSubjectInput(props: EmailTemplateAndSubjectInputPropsType) {
  const { templates, defaultTemplate } = props;

  return (
    <Fragment>
      {templates.length > 0 && (
        <Fragment>
          <AutocompleteInput
            optionText={(record: ExternalEmailTemplateRecordType) => `${record.name} (#${record.external_id})`}
            label="emailing.template"
            source="template"
            choices={templates}
            fullWidth
            validate={required()}
            sx={{ display: templates.length > 1 ? "block" : "none" }}
          />
          {manageEmailingSenders() && (
            <ReferenceInput source="sender" reference="email_senders" filter={{ assigned_only: true }}>
              <HideableAutocompleteInput
                filterToQuery={(search) => ({ search })}
                optionText={(record: EmailSenderRecordType) => `${record.name} (${record.email})`}
                label="emailing.sender"
                validate={required()}
                defaultTemplate={defaultTemplate}
              />
            </ReferenceInput>
          )}
        </Fragment>
      )}
      <TextInput source="subject" label="emailing.subject" fullWidth validate={required()} autoFocus />
      <HiddenInput source="scheduled_at" />
    </Fragment>
  );
}
